import React from "react";
import styled from "styled-components";

import { MainWorkspaceIcon } from "@/components/MondayBasics/MondayWorkspaceIcon/MainWorkspaceIcon";
import { WorkspaceIcon } from "@/components/MondayBasics/MondayWorkspaceIcon/WorkspaceIcon";
import { mainWorkspace } from "@/components/QuickSearch/utils/mainWorkspace";

type WorkspaceIconContainerProps = React.ComponentProps<typeof WorkspaceIcon> & {
  workspaceId: string;
};

const WorkspaceIconWrapper = styled.div``;

export const WorkspaceIconContainer: React.FC<WorkspaceIconContainerProps> = ({
  workspaceId,
  workspaceName,
  icon,
  color,
  size,
}) => {
  return (
    <WorkspaceIconWrapper>
      {workspaceId === `${mainWorkspace.id}` ? (
        <MainWorkspaceIcon name={workspaceName} size={size} iconColor={color} />
      ) : (
        <WorkspaceIcon icon={icon} workspaceName={workspaceName} color={color} size={size} />
      )}
    </WorkspaceIconWrapper>
  );
};
